import { render, staticRenderFns } from "./submitApproval.vue?vue&type=template&id=7cc19516&scoped=true"
import script from "./submitApproval.vue?vue&type=script&lang=js"
export * from "./submitApproval.vue?vue&type=script&lang=js"
import style0 from "./submitApproval.vue?vue&type=style&index=0&id=7cc19516&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc19516",
  null
  
)

export default component.exports